import { AccordionItem, PanelConfig } from '../types/config';

export const accordionItems: AccordionItem[] = [
  {
    title: "Come funziona?",
    images: [
      {
        url: "/zip_file_brand.png",
        subtitle: "Step 1",
        variableSubtitle: "Carica due file ZIP: uno contenente i documenti digitali originali e uno con i documenti scannerizzati da confrontare."
      },
      {
        url: "/fill_file_brand.png",
        subtitle: "Step 2",
        variableSubtitle: "Opzionalmente, specifica le pagine da analizzare. Clicca su 'Controlla Similarity' per avviare il confronto automatico."
      },
      {
        url: "/robotic_brand.png",
        subtitle: "Step 3",
        variableSubtitle: "Attendi il completamento dell'analisi. Potrai monitorare lo stato in tempo reale e scaricare il report Excel con i risultati."
      }
    ]
  }
];

export const panelConfig: PanelConfig = {
  title: "DocSimilarity",
  brightnessOnHover: 90,
  imageUrl: 'pdf_to_txt_smallversion.png'
};
